var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PageWrapper", {
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "el-header",
              { ref: "header", staticStyle: { height: "auto" } },
              [
                _c(
                  "el-form",
                  {
                    ref: "searchFormRef",
                    staticClass: "demo-form-inline",
                    attrs: { inline: true, model: _vm.searchForm },
                  },
                  [
                    _c(
                      "div",
                      { attrs: { id: "searchBox" } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "xhname" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "型号" },
                              nativeOn: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleSearchBtn.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                              model: {
                                value: _vm.searchForm.xhname,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "xhname", $$v)
                                },
                                expression: "searchForm.xhname",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "xhname_ct" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "型号包含" },
                              nativeOn: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleSearchBtn.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                              model: {
                                value: _vm.searchForm.xhname_ct,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "xhname_ct", $$v)
                                },
                                expression: "searchForm.xhname_ct",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "xhname_nct" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "型号不包含" },
                              nativeOn: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleSearchBtn.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                              model: {
                                value: _vm.searchForm.xhname_nct,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "xhname_nct", $$v)
                                },
                                expression: "searchForm.xhname_nct",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { type: "text", id: "closeSearchBtn" },
                        on: { click: _vm.closeSearch },
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.word) + " "),
                        _c("i", {
                          class: _vm.showAll
                            ? "el-icon-arrow-up "
                            : "el-icon-arrow-down",
                        }),
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "small",
                          icon: "el-icon-search",
                        },
                        on: { click: _vm.handleSearchBtn },
                      },
                      [_vm._v("搜索 ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", icon: "el-icon-refresh" },
                        on: { click: _vm.handleResetBtn },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "upload-container" },
              [
                _c(
                  "el-button",
                  {
                    directives: [{ name: "waves", rawName: "v-waves" }],
                    staticClass: "filter-item",
                    attrs: {
                      loading: _vm.importLoading,
                      type: "warning",
                      icon: "el-icon-plus",
                      size: "small",
                    },
                    on: { click: _vm.handleImport },
                  },
                  [_vm._v("导入Excel ")]
                ),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.listLoading,
                        expression: "listLoading",
                      },
                    ],
                    staticClass: "customer-table",
                    attrs: {
                      border: "",
                      fit: "",
                      "highlight-current-row": "",
                      data: _vm.list,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "型号", prop: "xhname" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "品牌", prop: "source" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "原币价格", prop: "price" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "供应商", prop: "gongyingshang" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "上传日期", prop: "upload_date" },
                    }),
                  ],
                  1
                ),
                _c("el-pagination", {
                  staticStyle: {
                    "margin-top": "14px",
                    "margin-bottom": "14px",
                  },
                  attrs: {
                    "current-page": _vm.selectPage.pageNum,
                    "page-sizes": [20, 50, 100, 200],
                    "page-size": _vm.selectPage.pageSize,
                    background: "",
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.allNum,
                  },
                  on: {
                    "size-change": _vm.pageSizeChange,
                    "current-change": _vm.pageCurrentChange,
                  },
                }),
                _c("Import", {
                  attrs: { dialog: _vm.dialogImport },
                  on: {
                    close: _vm.handleImportClose,
                    uploadSuccess: _vm.handleUpload,
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }